import type { ParameterField, PendingParameters } from './validatePendingParameters';

const ORDER: ParameterField[] = ['groupSize', 'date', 'time'];

function isSet(field: ParameterField, pending: PendingParameters): boolean {
	if (field === 'groupSize') {
return typeof pending.groupSize === 'number' && pending.groupSize > 0;
}
	if (field === 'date') {
return !!pending.date;
}
	return !!pending.time;
}

export function getNextUnsetParameterField(
	pending: PendingParameters,
	afterField?: ParameterField
): ParameterField | null {
	const startIdx = afterField !== undefined ? ORDER.indexOf(afterField) + 1 : 0;
	for (let i = startIdx; i < ORDER.length; i++) {
		if (!isSet(ORDER[i], pending)) {
return ORDER[i];
}
	}
	return null;
}
